import React from "react";
import ReactTooltip from "react-tooltip";

class ProductDescription extends React.Component {

  render() {
    const { description, soundsecure, speedset } = this.props;
    let bulletList = [];
    let descriptions = description.split(',');

    descriptions.forEach(function(obj){
      bulletList.push(obj);
    });


    return (
      <div className="product-description row">
        <div className="col-md-7 col-xs-12">
          <ul>
            {bulletList.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>
        </div>
        <div className="col-md-5 col-xs-12">
          <div className="product-logos">
            {soundsecure || speedset ? <h3>Also available in:</h3> : null}
            {soundsecure &&
              <div className="logo-detail">
                <img src={`/wp-content/themes/uniform_base/assets/img/app/icon-soundsecure.svg`} alt="soundsecure" />
                <span>SoundSecure</span>
                <a data-tip data-for='SoundSecure'>i</a>
                <ReactTooltip id='SoundSecure' effect='solid' className='logo-tooltip'>
                <span>This product is available within our Internal SoundSecure Apartment Entrance Doorset offer (size dependant) - please refer to the Internal Doorset page for more information.</span>
                </ReactTooltip>
              </div>
            }
            {speedset &&
            <div className="logo-detail">
              <img src={`/wp-content/themes/uniform_base/assets/img/app/icon-speedset.svg`} alt="speedset" />
              <span>SpeedSet</span>
              <a data-tip data-for='SpeedSet'>i</a>
              <ReactTooltip id='SpeedSet' effect='solid' className='logo-tooltip'>
                <span>This product is available within our SpeedSet Plus Internal Doorset offer (size dependant) - please refer to the Internal Doorset page for more information.</span>
              </ReactTooltip>
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDescription;
